import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./footer.css";
import MhomeLogo from "../image/MhomeLogo.png";

function Footer() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-top">
        <h2>{t("footer_cta_title", "Ready to Transform Your Space?")}</h2>
        <p>
          {t(
            "footer_cta_text",
            "Let's discuss your vision and create something extraordinary together. Schedule a consultation with our design team today."
          )}
        </p>
        <div className="footer-buttons">
          <button className="btn btn-get" onClick={() => navigate("/contact")}>
            {t("btn_contact")}
          </button>
          <button className="btn btn-portfolio" onClick={() => navigate("/our-work")}>
            {t("btn_explore")}
          </button>
        </div>
      </div>

      <div className="footer-middle">
        <div className="footer-brand">
          <div className="brand-row">
            <img src={MhomeLogo} alt="MHome Logo" className="brand-logo" />
          </div>
          <p className="brand-text">
            {t(
              "footer_brand_text",
              "Transforming spaces with custom wall panel designs and bespoke furniture crafted with precision and passion."
            )}
          </p>
        </div>

        <div className="footer-section">
          <h3>{t("footer_quick_links", "Quick Links")}</h3>
          <ul>
            <li><Link className="footer-link" to="/">{t("nav_home")}</Link></li>
            <li><Link className="footer-link" to="/about">{t("nav_about")}</Link></li>
            <li><Link className="footer-link" to="/our-work">{t("nav_work")}</Link></li>
            <li><Link className="footer-link" to="/contact">{t("nav_contact")}</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>{t("footer_contact", "Contact")}</h3>
          <p>{t("footer_phone", "+1 (555) 123-4567")}</p>
          <p>{t("footer_email", "hello@mhome.com")}</p>
          <p>{t("footer_address", "123 Design Street, NY 10001")}</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2024 MHome. {t("footer_rights", "All rights reserved.")}</p>
      </div>
    </footer>
  );
}

export default Footer;
